import './App.scss';
import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from "@vercel/speed-insights/react";
import ScrollToTop from './Components/ScrollToTop';

// Lazy load pages for better performance
const Home = lazy(() => import('./Pages/Home'));
const Productlist = lazy(() => import('./Pages/Productlist'));
const Cataloguepage = lazy(() => import('./Pages/Cataloguepage'));
const Contact = lazy(() => import('./Pages/Contact'));
const Valve = lazy(() => import('./Components/Valve'));
const ValvAutomation = lazy(() => import('./Components/ValveAutomation'));
const SSTCFittingsValves = lazy(() => import('./Components/SSTCFittings&Valves'));

// Loading fallback
const PageLoader = () => (
  <div className="flex items-center justify-center h-screen bg-white">
    <div className="flex flex-col items-center gap-4">
      <div className="w-10 h-10 border-4 border-brand-200 border-t-brand-500 rounded-full animate-spin" />
      <p className="text-brand-500 font-medium" style={{ fontFamily: 'Cabin, sans-serif' }}>Loading...</p>
    </div>
  </div>
);

export default function App() {
  return (
    <>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route index path='/' element={<Home />} />
              <Route path='/products' element={<Productlist />} />
              <Route path='/catalogues' element={<Cataloguepage />} />
              <Route path='/contactus' element={<Contact />} />
              <Route path='/products/valve' element={<Valve />} />
              <Route path='/products/Valve-Automation' element={<ValvAutomation />} />
              <Route path='/products/SS-TC-Fittings-Valves' element={<SSTCFittingsValves />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </div>
      <Analytics />
      <SpeedInsights />
    </>
  );
}
